import type { MailRibbonConfigStore } from 'owa-mail-ribbon-store-shared-types';
import { LabelPreferenceId } from 'owa-mail-ribbon-store-shared-types';
import { MailRibbonTabId } from 'owa-ribbon-ids';
import { createStore } from 'satcheljs';

function getTabScalingAndLayoutConfigInit(showLabelsPreference: LabelPreferenceId) {
    return {
        layout: [],
        controlsInOverflow: [],
        staticGroupIdOrdering: [],
        removedDefaultGroups: [],
        showLabelsPreference,
    };
}

export const initialEmptyRibbonConfig: MailRibbonConfigStore = {
    version: 0,
    multiline: {
        homeTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.ShowAsSpacePermits),
        viewTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.ShowAsSpacePermits),
        messageTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.ShowAsSpacePermits),
        insertTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.ShowAsSpacePermits),
        formatTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.ShowAsSpacePermits),
        notesTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.ShowAsSpacePermits),
        tableFormatTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.ShowAsSpacePermits),
        readTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.ShowAsSpacePermits),
    },
    singleline: {
        homeTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.ShowAsSpacePermits),
        viewTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.ShowAsSpacePermits),
        messageTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.ShowAsSpacePermits),
        messageTabM3: getTabScalingAndLayoutConfigInit(LabelPreferenceId.ShowAsSpacePermits),
        insertTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.ShowAsSpacePermits),
        formatTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.ShowAsSpacePermits),
        notesTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.ShowAsSpacePermits),
        tableFormatTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.ShowAsSpacePermits),
        readTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.ShowAsSpacePermits),
        optionsTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.ShowAsSpacePermits),
    },
    toolbar: {
        homeTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.AlwaysShow),
        messageTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.AlwaysShow),
        readonlyTab: getTabScalingAndLayoutConfigInit(LabelPreferenceId.AlwaysShow),
    },
    selectedTab: MailRibbonTabId.Tab_Home,
    contextualTabs: [],
};
export const getStore = createStore<MailRibbonConfigStore>(
    'MailRibbonConfiguration',
    initialEmptyRibbonConfig
);

export default getStore();
